<template lang="pug">
span.status-badge(:class='badgeClass')
  icon-status(:icon-status='status')
  span {{ $t(status) }}
</template>

<script>
import IconStatus from '@/ui/atoms/IconStatus.vue';
import EnvelopeState from '@/enums/EnvelopeState';
import RecipientState from '@/enums/RecipientState';
import EnvelopeStatus from '@/enums/EnvelopeStatus';

export default {
  name: 'StatusBadge',
  components: {
    IconStatus,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeClass() {
      switch (this.status) {
        case 'sent':
        case 'processing':
        case EnvelopeState.IN_TRANSIT:
        case RecipientState.QUEUED:
        case RecipientState.WAITING:
        case EnvelopeStatus.PENDING:
          return 'status-badge--pending';
        case EnvelopeState.CANCELLED:
        case EnvelopeState.EXPIRED:
        case EnvelopeState.HALTED:
        case EnvelopeState.REFUSED:
        case RecipientState.FAILED:
          return 'status-badge--canceled';
        case EnvelopeState.COMPLETED:
        case RecipientState.DONE:
          return 'status-badge--finished';
        case EnvelopeState.PROCESSING:
        case RecipientState.FOLLOWING:
        case RecipientState.SUSPENDED:
        case RecipientState.SIGNING:
          return 'status-badge--suspended';
        case EnvelopeStatus.REJECTED:
        case RecipientState.REFUSED:
          return 'status-badge--rejected';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.status-badge
  display: inline-flex
  align-items: center
  gap: 0.4rem
  padding: 0.25rem 0.7rem
  border-radius: 20px
  font-size: 0.8rem
  font-weight: 600
  white-space: nowrap
  background-color: #F0F0F0
  color: #707070

  &--pending
    background-color: #FFF6DD
    color: #B38600

  &--finished
    background-color: #E7F0EF
    color: #19665B

  &--canceled
    background-color: #FDECEA
    color: #C0392B

  &--suspended
    background-color: #EAF1FB
    color: #2C6FBB

  &--rejected
    background-color: #FDECEA
    color: #C0392B
</style>
